module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-8bbbf07a96f614a3849b681885be45bf.otf";